__turbopack_export_value__({
  "card": "schedule-module__znx0HW__card",
  "cardBody": "schedule-module__znx0HW__cardBody",
  "cardSlot": "schedule-module__znx0HW__cardSlot",
  "cardSlotLeft": "schedule-module__znx0HW__cardSlotLeft",
  "cardSlotRight": "schedule-module__znx0HW__cardSlotRight",
  "cardTitle": "schedule-module__znx0HW__cardTitle",
  "copy": "schedule-module__znx0HW__copy",
  "dateBadge": "schedule-module__znx0HW__dateBadge",
  "description": "schedule-module__znx0HW__description",
  "eyebrow": "schedule-module__znx0HW__eyebrow",
  "header": "schedule-module__znx0HW__header",
  "headerText": "schedule-module__znx0HW__headerText",
  "image": "schedule-module__znx0HW__image",
  "imageOverlay": "schedule-module__znx0HW__imageOverlay",
  "inner": "schedule-module__znx0HW__inner",
  "locationAddress": "schedule-module__znx0HW__locationAddress",
  "locationArrow": "schedule-module__znx0HW__locationArrow",
  "locationCard": "schedule-module__znx0HW__locationCard",
  "locationIcon": "schedule-module__znx0HW__locationIcon",
  "locationLabel": "schedule-module__znx0HW__locationLabel",
  "locationName": "schedule-module__znx0HW__locationName",
  "locationText": "schedule-module__znx0HW__locationText",
  "marker": "schedule-module__znx0HW__marker",
  "markerInner": "schedule-module__znx0HW__markerInner",
  "media": "schedule-module__znx0HW__media",
  "progressLine": "schedule-module__znx0HW__progressLine",
  "section": "schedule-module__znx0HW__section",
  "subtitle": "schedule-module__znx0HW__subtitle",
  "summary": "schedule-module__znx0HW__summary",
  "timeBadge": "schedule-module__znx0HW__timeBadge",
  "timeline": "schedule-module__znx0HW__timeline",
  "timelineItem": "schedule-module__znx0HW__timelineItem",
  "timelineItemRight": "schedule-module__znx0HW__timelineItemRight",
  "title": "schedule-module__znx0HW__title",
});
